module.exports = "pegasus/assets/tech/holiday_2/100.png";